// Auto-generated by splitter.py — do not regenerate; edit directly.

import { DesignPreviewCard } from '../modules/comms/DesignPreviewCard';

export const CAMPAIGNS_SEED = [
  { id: 'CMP-2026-014', name: 'AFCON Q · 24h reminder',          channel: 'WhatsApp', audience: 'FUFA event buyers',           audienceSize: 8930,  sent: 8821, opened: 6402, clicks: 1480, status: 'Sent',     when: '15 May 2026 · 18:00', by: 'Mariam K.' },
  { id: 'CMP-2026-013', name: 'Akibua Match-Day promo',           channel: 'Email',    audience: 'All past buyers',             audienceSize: 18420, sent: 18302, opened: 9418, clicks: 2104, status: 'Sent',     when: '12 May 2026 · 10:15', by: 'Lillian K.' },
  { id: 'CMP-2026-012', name: 'Nyege Nyege early-bird',           channel: 'Email',    audience: 'Past festival attendees',    audienceSize: 4210,  sent: 4210, opened: 3018, clicks: 1840, status: 'Sent',     when: '08 May 2026 · 09:00', by: 'Victor S.' },
  { id: 'CMP-2026-011', name: 'Season renewal · cinema',          channel: 'SMS',      audience: 'Cinema regulars',             audienceSize: 2148,  sent: 2148, opened: 0, clicks: 312,    status: 'Sent',     when: '04 May 2026 · 12:30', by: 'Lillian K.' },
  { id: 'CMP-2026-010', name: 'Cart abandon · reminder',          channel: 'WhatsApp', audience: 'Cart abandoners (30d)',       audienceSize: 612,   sent: 612, opened: 411, clicks: 188,    status: 'Sent',     when: '01 May 2026 · 19:00', by: 'Auto · system' },
];


export const DESIGN_TEMPLATES = [
  {
    id: 'tmpl-match-classic', name: 'Match-day classic',
    desc: 'Bold header, large gate/section/seat block, sponsor strip',
    style: 'classic', headerColor: '#1F2937', accentColor: '#C48319',
    defaults: { eventName: true, venue: true, dateTime: true, gate: true, section: true, row: true, seat: true, category: true, qr: true, buyerName: true, organizer: true, terms: false, sponsor: true },
    bestFor: 'Football, rugby, reserved seating',
  },
  {
    id: 'tmpl-festival-band', name: 'Festival wristband',
    desc: 'Minimal layout, no seat fields, large QR, day-pass markers',
    style: 'wristband', headerColor: '#2F8B4F', accentColor: '#15803D',
    defaults: { eventName: true, venue: true, dateTime: true, gate: false, section: false, row: false, seat: false, category: true, qr: true, buyerName: false, organizer: true, terms: false, sponsor: false },
    bestFor: 'Music festivals, general admission',
  },
  {
    id: 'tmpl-cinema', name: 'Cinema showtime',
    desc: 'Row + seat focus, showtime block, screen number, no gate',
    style: 'cinema', headerColor: '#7A1F1F', accentColor: '#9B1F1F',
    defaults: { eventName: true, venue: true, dateTime: true, gate: false, section: true, row: true, seat: true, category: true, qr: true, buyerName: true, organizer: false, terms: false, sponsor: false },
    bestFor: 'Cinema, theatre, auditorium',
  },
  {
    id: 'tmpl-conference', name: 'Conference badge',
    desc: 'Large name, role, organization, lanyard fold lines',
    style: 'badge', headerColor: '#1F2937', accentColor: '#2563EB',
    defaults: { eventName: true, venue: true, dateTime: true, gate: false, section: false, row: false, seat: false, category: true, qr: true, buyerName: true, organizer: true, terms: false, sponsor: true },
    bestFor: 'Conferences, summits, expos',
  },
  {
    id: 'tmpl-wallet-min', name: 'Wallet minimal',
    desc: 'Apple Wallet / Google Pay optimized, mono colors, no decoration',
    style: 'wallet', headerColor: '#000000', accentColor: '#1F2937',
    defaults: { eventName: true, venue: true, dateTime: true, gate: true, section: true, row: true, seat: true, category: true, qr: true, buyerName: true, organizer: true, terms: false, sponsor: false },
    bestFor: 'Wallet passes, mobile-first',
  },
  {
    id: 'tmpl-vip', name: 'VIP premium',
    desc: 'Foil-style header, embossed accents, hospitality info area',
    style: 'vip', headerColor: '#5B3D1F', accentColor: '#C48319',
    defaults: { eventName: true, venue: true, dateTime: true, gate: true, section: true, row: true, seat: true, category: true, qr: true, buyerName: true, organizer: true, terms: true, sponsor: true },
    bestFor: 'VIP, hospitality, corporate boxes',
  },
];

/* ============================================================================
   EMAIL TEMPLATES — parallel to ticket designs, with toggleable blocks + text
   ============================================================================ */


export const EMAIL_BLOCKS = [
  { k: 'preheader',     label: 'Preheader',          default: true,  text: true,  required: false, placeholder: 'Your tickets are ready · See you at the gate' },
  { k: 'hero',          label: 'Hero image / header',default: true,  text: false, required: false },
  { k: 'headline',      label: 'Headline',           default: true,  text: true,  required: true,  placeholder: 'Your tickets are confirmed' },
  { k: 'subheadline',   label: 'Sub-headline',       default: true,  text: true,  required: false, placeholder: 'See you on match-day. Show this email at the gate.' },
  { k: 'ticketSummary', label: 'Ticket summary',     default: true,  text: false, required: true },
  { k: 'eventDetails',  label: 'Event details',      default: true,  text: false, required: true },
  { k: 'cta',           label: 'Primary CTA button', default: true,  text: true,  required: false, placeholder: 'View my tickets' },
  { k: 'qrInline',      label: 'Inline QR code',     default: false, text: false, required: false },
  { k: 'addToCalendar', label: 'Add-to-calendar',    default: true,  text: false, required: false },
  { k: 'organizer',     label: 'Organizer block',    default: true,  text: false, required: false },
  { k: 'venue',         label: 'Venue / directions', default: true,  text: false, required: false },
  { k: 'help',          label: 'Help & support',     default: true,  text: false, required: false },
  { k: 'social',        label: 'Social links',       default: false, text: false, required: false },
  { k: 'footer',        label: 'Footer / unsubscribe',default: true, text: true,  required: true,  placeholder: 'TKT · Plot 12, Kampala Road · Manage preferences' },
];


export const EMAIL_TEMPLATES = [
  {
    id: 'em-tmpl-confirm',  name: 'Ticket Confirmation',
    desc: 'Hero + ticket summary + CTA + event details. The default purchase confirmation.',
    style: 'confirmation', headerColor: '#1F2937', accentColor: '#2F8B4F',
    subject: 'Your tickets to {eventName} are confirmed',
    blocks: { preheader: true, hero: true, headline: true, subheadline: true, ticketSummary: true, eventDetails: true, cta: true, qrInline: false, addToCalendar: true, organizer: true, venue: true, help: true, social: false, footer: true },
    text: { preheader: 'Your tickets are ready · See you at {venue}', headline: 'Your tickets are confirmed', subheadline: 'You\'re all set for {eventName}. Show this email at the gate.', cta: 'View my tickets', footer: 'TKT · Plot 12, Kampala Road · Manage preferences' },
    bestFor: 'Purchase confirmation',
  },
  {
    id: 'em-tmpl-receipt', name: 'Payment Receipt',
    desc: 'Receipt-first layout · transaction details · VAT line · paid badge',
    style: 'receipt', headerColor: '#1F2937', accentColor: '#1F2937',
    subject: 'Payment received · {amount} · {eventName}',
    blocks: { preheader: true, hero: false, headline: true, subheadline: false, ticketSummary: true, eventDetails: true, cta: true, qrInline: false, addToCalendar: false, organizer: false, venue: false, help: true, social: false, footer: true },
    text: { preheader: 'Receipt for your TKT purchase', headline: 'Payment received', subheadline: '', cta: 'Download receipt (PDF)', footer: 'TKT · VAT TIN 1003456789 · Invoice queries' },
    bestFor: 'Receipts & invoices',
  },
  {
    id: 'em-tmpl-reminder', name: 'Event Reminder · T-24h',
    desc: 'Date/time emphasis, gate map, parking info, weather block',
    style: 'reminder', headerColor: '#C48319', accentColor: '#C48319',
    subject: 'Tomorrow · {eventName} at {venue}',
    blocks: { preheader: true, hero: true, headline: true, subheadline: true, ticketSummary: false, eventDetails: true, cta: true, qrInline: true, addToCalendar: true, organizer: false, venue: true, help: true, social: false, footer: true },
    text: { preheader: 'See you tomorrow at {venue}', headline: 'Tomorrow — {eventName}', subheadline: 'Gates open at {gateOpen}. Bring this email or your wallet pass.', cta: 'See gate map', footer: 'TKT · Travel & gate guide' },
    bestFor: 'Pre-event reminders',
  },
  {
    id: 'em-tmpl-refund', name: 'Refund Issued',
    desc: 'Clean, minimal, no decoration · refund line + timeline',
    style: 'refund', headerColor: '#7A1F1F', accentColor: '#7A1F1F',
    subject: 'Refund issued · {amount} for {eventName}',
    blocks: { preheader: true, hero: false, headline: true, subheadline: true, ticketSummary: true, eventDetails: false, cta: false, qrInline: false, addToCalendar: false, organizer: false, venue: false, help: true, social: false, footer: true },
    text: { preheader: 'Your refund is on its way', headline: 'Refund issued', subheadline: 'We\'ve refunded {amount} to your {paymentMethod}. It typically arrives within 3 business days.', cta: '', footer: 'TKT · Refund support' },
    bestFor: 'Refund notifications',
  },
  {
    id: 'em-tmpl-marketing', name: 'Marketing — Event Launch',
    desc: 'Big hero, bold headline, social links, browse-events CTA',
    style: 'marketing', headerColor: '#5B3D1F', accentColor: '#C48319',
    subject: 'Tickets on sale: {eventName}',
    blocks: { preheader: true, hero: true, headline: true, subheadline: true, ticketSummary: false, eventDetails: true, cta: true, qrInline: false, addToCalendar: false, organizer: true, venue: true, help: false, social: true, footer: true },
    text: { preheader: 'Don\'t miss this · tickets on sale now', headline: 'Tickets on sale now', subheadline: 'Be the first at {eventName}. VIP and early-bird tiers available.', cta: 'Get my tickets', footer: 'TKT · You\'re subscribed because you bought from a similar event · Unsubscribe' },
    bestFor: 'Campaigns & launches',
  },
  {
    id: 'em-tmpl-transfer', name: 'Ticket Transferred',
    desc: 'Sender / recipient summary, transfer audit info, scan-ready notice',
    style: 'transfer', headerColor: '#2563EB', accentColor: '#2563EB',
    subject: 'A ticket has been transferred to you',
    blocks: { preheader: true, hero: false, headline: true, subheadline: true, ticketSummary: true, eventDetails: true, cta: true, qrInline: true, addToCalendar: true, organizer: false, venue: true, help: true, social: false, footer: true },
    text: { preheader: '{senderName} sent you a ticket to {eventName}', headline: 'A ticket is now yours', subheadline: 'From {senderName} · scan-ready in your wallet', cta: 'Open in wallet', footer: 'TKT · Ticket transfers are final' },
    bestFor: 'Ticket transfers',
  },
];

/* DesignPreviewCard — renders ticket OR email preview from a template + toggles */
